<ng-container *ngIf="mainForm !== undefined && control">
  <div [formGroup]="mainForm" [ngClass]="{
      'hasPrefix': prefix,
      'hasSuffix': suffix,
      'mm-suffix': type === 'number' && suffix === 'mm',
      'percent-suffix': type === 'number' && suffix === 'percent',
      'currency-suffix': type === 'number' && suffix === 'currency',
      'days-suffix': type === 'number' && suffix === 'days',
      'inputField_error': state === 'error' || (control.invalid && (control.dirty || control.touched) && !control.errors?.required),
      'inputField_required': state === 'required' || (control.invalid && (control.dirty || control.touched) && control.errors && control.errors.required),
      'inputField_updated': state === 'updated' || highlight,
      'inputField_new': state === 'new',
      'autoWidth': autoWidth,
      'with-char-counter': charCounter
    }" class="inputField {{layoutModifier}}" (click)="onAutoWidthClick()">
    <span class="inputField_prefix" *ngIf="prefix">{{prefix}}</span>
    <ng-container *ngIf="autoWidth; else defaultView">
      <span class="inputField_wrap">
        <span class="inputField_wrap-width">{{control?.value}}</span>
        <input #input [attr.type]="type" [attr.step]="valueOfStep" [formControlName]="controlName" [placeholder]="placeholder | translate"
          *ngIf="!autoFocus" [ngClass]="['text-'+textAlign || '']" (keyup.enter)="onEnter($event)" (input)="updateCount($event)">
        <input #input [attr.type]="type" [attr.step]="valueOfStep" [formControlName]="controlName" [placeholder]="placeholder | translate" *ngIf="autoFocus"
          autoFocus [ngClass]="['text-'+textAlign || '']" (keyup.enter)="onEnter($event)" (input)="updateCount($event)">
        <span *ngIf="charCounter" class="char-counter">{{ currentLength }}/{{ maxChars }}</span>
      </span>
    </ng-container>
    <ng-template #defaultView>
      <input [attr.type]="type" [attr.step]="valueOfStep" [formControlName]="controlName" [placeholder]="placeholder | translate"
        *ngIf="!autoFocus" [ngClass]="['text-'+textAlign || '']" (keyup.enter)="onEnter($event)" (input)="updateCount($event)">
      <input [attr.type]="type" [attr.step]="valueOfStep" [formControlName]="controlName" [placeholder]="placeholder | translate" *ngIf="autoFocus"
        autoFocus [ngClass]="['text-'+textAlign || '']" (keyup.enter)="onEnter($event)" (input)="updateCount($event)">
    </ng-template>
    <span class="inputField_suffix" *ngIf="suffix && type !== 'number'">{{suffix}}</span>
    <span *ngIf="charCounter" class="char-counter">{{ currentLength }}/{{ maxChars }}</span>
  </div>

  <app-form-errors *ngIf="control.errors" [control]="control" tabindex="-1"></app-form-errors>

</ng-container>
